import { H3 } from '@h3/types';
import { request } from '@h3/request';
import * as Api from './constant';

/** 消息发送方 */
export const getSendUser = (data: {
    sendSideType: H3.Plugin.WxworkUserType;
    keyword: string;
    limit: number;
    cursor: string;
}) => {
    return request<
        H3.Http.Response.H3Response<{
            dataList: H3.Plugin.WxworkChatSendUser[];
            nextCursor: string;
            hasMore: boolean;
        }>
    >(Api.sendsides, {
        method: H3.Http.MethodType.POST,
        data,
    });
};

/** 消息接受方 */
export const getReceivedUser = (data: {
    sendSideType: H3.Plugin.WxworkUserType;
    sendSideId: string;
    receiveSideType: H3.Plugin.WxworkUserType;
    keyword: string;
    limit: number;
    cursor: string;
}) => {
    return request<
        H3.Http.Response.H3Response<{
            dataList: H3.Plugin.WxworkChatReceivedUser[];
            nextCursor: string;
            hasMore: boolean;
        }>
    >(Api.receivesides, {
        method: H3.Http.MethodType.POST,
        data,
    });
};

/** 获取聊天记录 */
export const getChatrecord = (data: {
    sendSideType: H3.Plugin.WxworkUserType;
    sendSideId: string;
    receiveSideType: H3.Plugin.WxworkUserType;
    receiveSideId: string;
    msgTypeList: H3.Plugin.WxworkchatType[];
    startTime: string;
    endTime: string;
    keyword: string;
    limit: number;
    cursor: string;
}) => {
    return request<
        H3.Http.Response.H3Response<{
            dataList: H3.Plugin.WxworkChatMessage[];
            nextCursor: string;
            hasMore: boolean;
        }>
    >(Api.chatrecord, {
        method: H3.Http.MethodType.POST,
        data,
    });
};

export const getChatrecordByMessageId = (data: { msgId: string; beforeCount: number; afterCount: number }) => {
    return request<
        H3.Http.Response.H3Response<{
            dataList: H3.Plugin.WxworkChatMessage[];
            nextCursor: string;
            hasMore: boolean;
        }>
    >(Api.getChatrecordByMessId, {
        method: H3.Http.MethodType.POST,
        data,
    });
};
/** 同步聊天记录 */
export const asyncChatrecord = () => {
    return request<H3.Http.Response.H3Response<string>>(Api.asyncChatrecord, {
        method: H3.Http.MethodType.POST,
    });
};
/** 获取会话总结 */
export const getChatSummary = (data: { sessionObjectId: string; startTime: string; endTime: string }) => {
    return request<
        H3.Http.Response.H3Response<{
            jobId: string;
            msgCount: number;
        }>
    >(Api.chatSummary, {
        method: H3.Http.MethodType.POST,
        data,
    });
};
/** 获取会话总结结果 */
export const getChatSummaryResult = (jobId: string) => {
    return request<
        H3.Http.Response.H3Response<{
            status: 0 | 1 | 2;
            response_data: string;
        }>
    >(`${Api.getChatSummaryResult}?jobId=${jobId}`, {
        method: H3.Http.MethodType.POST,
    });
};

export const getchatConfig = () => {
    return request<
        H3.Http.Response.H3Response<{
            isAutoSyncBasicData: boolean; // 自动同步基础数据
            isAutoSyncSession: boolean; // 自动同步会话开关
            isSessionSummary: boolean; // 会话总结开关
            isSentimentAnalysis: boolean;
        }>
    >(Api.getchatConfig, {
        method: H3.Http.MethodType.GET,
    });
};
